import { render } from "./ProsesKategoriSatker.vue?vue&type=template&id=7a026a12"
import script from "./ProsesKategoriSatker.vue?vue&type=script&lang=js"
export * from "./ProsesKategoriSatker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__